import { notification } from 'antd'

notification.config({
  placement: 'bottomRight',
  duration: 3,
})

// antd 6: `message` đã deprecated, tiêu đề đi qua `title`. Gửi cả hai thì antd vẫn log cảnh báo.
export const notify = {
  success: (message: string, description?: string) => {
    notification.success({
      title: message,
      description,
      className: 'notification-custom-success',
    })
  },
  error: (message: string, description?: string) => {
    notification.error({
      title: message,
      description,
      className: 'notification-custom-error',
    })
  },
  info: (message: string, description?: string) => {
    notification.info({
      title: message,
      description,
      className: 'notification-custom-info',
    })
  },
  warning: (message: string, description?: string) => {
    notification.warning({
      title: message,
      description,
      className: 'notification-custom-warning',
    })
  },
}
